/* src/app/dashboard/stats/stats.component.css */
.mm_container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 95%;
}
.mm_row {
  display: flex;
  flex: 1 1 100%;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
}
.mm_row_icon {
  font-size: 55px;
  font-weight: bold;
  color: var(--primary-color);
  margin-right: 15px;
}
.mm_row_icon_subheader {
  color: var(--secondary-color);
  font-size: 18px;
  font-weight: normal;
  display: block;
}
.mm_row_text {
  color: #fc0001;
  font-size: 2.5vw;
  font-weight: normal;
  display: flex;
  flex: 1 1 auto;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.mm_bottom_border {
  border-bottom-color: #e0e1e2;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  padding-bottom: 16px;
}
.arrow {
  margin-right: 5px;
}
.fade_arrow {
  opacity: 0.5;
}
.mr_arrow {
  margin-right: 10px;
}
.ml_arrow {
  margin-left: 10px;
}
@media (max-width: 600px) {
  .mm_row_icon {
    font-size: 35px;
  }
  .mm_row_icon_subheader {
    font-size: 16px;
  }
  .mm_row_text {
    font-size: 25px;
  }
}
/*# sourceMappingURL=stats.component.css.map */
